import { ref } from "vue"
import { defineComponent, inferProps, propsWithDefaults, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import Form from "./Form"
import FormButtons from "./FormButtons"

interface Props {
	initialValue: string

	cancelText?: string
	okText?: string

	cancel(): void
	onSubmit(value: string): void
}

const TextEditForm: ReactiveComponent<Props> = (initialProps) => {
	const props = propsWithDefaults(initialProps, {
		okText: "Ok",
		cancelText: "Cancel",
	})

	const text = ref(props.initialValue)
	function handleSubmit(e: Event) {
		e.preventDefault()
		props.onSubmit(text.value)
	}

	return () => (
		<Form onSubmit={handleSubmit}>
			<input class="w-full" type="text" v-model={text.value} autofocus required />
			<br />
			<br />
			<FormButtons>
				<BootstrapButton type="button" color="secondary" onClick={props.cancel}>
					{props.cancelText}
				</BootstrapButton>
				<BootstrapButton type="submit" color="primary">
					{props.okText}
				</BootstrapButton>
			</FormButtons>
		</Form>
	)
}

export default defineComponent(TextEditForm, inferProps<Props>())
